export default __webpack_public_path__ + "static/media/hex-right.b6d429eb.svg";